import { createAction, props } from '@ngrx/store';

import { DeliveryLine, DeliveryTableLine } from '../models/delivery.model';

export const loadData = createAction('[Delivery] Load data', props<{ locationIds?: number[] }>());
export const clearDeliveryState = createAction('[Delivery] Clear Delivery state');

/*** LOAD DELIVERIES ***/
export const loadDeliveriesRequest = createAction(
  '[Delivery] Load Deliveries Request',
  props<{ locationIds?: number[] }>(),
);
export const loadDeliveriesSuccess = createAction(
  '[Delivery] Load Deliveries Success',
  props<{ deliveryLines: DeliveryLine[] }>(),
);
export const loadDeliveriesError = createAction(
  '[Delivery] Load Deliveries Error',
  props<{ error: Error }>(),
);

export const upsertDeliveryRequest = createAction(
  '[Delivery] Upsert Delivery Request',
  props<{ tableLine: DeliveryTableLine }>(),
);
export const upsertDeliverySuccess = createAction('[Delivery] Upsert Delivery Success');
export const upsertDeliveryError = createAction(
  '[Delivery] Upsert Delivery Error',
  props<{ error: Error }>(),
);
